import { isValidElement, ReactElement, ReactNode } from 'react'

import MenuList, { MenuListItemProps } from '~lib/ui-kit/MenuList'

export type OptionType = {
  value: string
  label: string
  icon?: ReactNode
  custom?: boolean
}

export type OptionProps = Prefer<
  {
    active?: boolean
    selected?: boolean
    disabled?: boolean
    icon?: ReactNode
    value?: unknown
    children?: string
    type?: 'button' | 'checkbox'
  },
  MenuListItemProps
>

function Option({ active, selected, disabled, type, value, children, ...props }: OptionProps) {
  return (
    <MenuList.Item
      active={active}
      selected={selected}
      disabled={disabled}
      data-value={value}
      aria-selected={selected}
      aria-disabled={disabled}
      role="option"
      type={type}
      {...props}
    >
      {children}
    </MenuList.Item>
  )
}

export default Option

/**
 * Type of option component as child
 */
export type ReactElementOption = ReactElement<OptionProps & Record<string, any>, typeof Option>

/**
 * Checks if value is valid select child
 */
export const isOptionComponent = (child: ReactNode) => {
  return isValidElement(child) && child.type === Option
}
